export const MIN_GRID_DIMENSION = 1;
// Covers scarves (~40–80 wide) through large blankets (300–500); keeps canvas performant
export const MAX_GRID_DIMENSION = 500;
